module.exports = __webpack_public_path__ + "60893a488a145469f80ea7559188837d.svg";